<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <img style="display: none;" id='reportLogo' crossorigin="Anonymous" src='https://bxi-upload-bucket.s3.ap-southeast-1.amazonaws.com/iripple-images/reports/iripple/1646293427892_report_logo.png' alt='Report Logo'>
            <div class="row no-gutters">
                <div class="col-md-9">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="From"><br>
                                    <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM/DD/YYYY hh:mm A" :placeholder="['Start Time', 'End Time']" style="width:100%"/>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select Site">
                                    <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-4">
                                <base-input label="Sort By" >
                                    <select class="form-control" v-model="inputSortBy">
                                        <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>
                            <div class="col-md-2 mt-3 pt-3">
                                <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' > 
                                    {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                                </button>
                            </div>
                        </div>
    
                        <div class="row">
                            <div class="col-md-4">
                                <base-input label="Status" >
                                    <select class="form-control" size="large" v-model="inputStatus">
                                        <option v-for="option in statusOptions" v-bind:value="option.key" v-bind:key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>
                        </div>
    
                        <!-- <div class="row">
                            <div class="col-md-4">
                                <base-input label="Format" >
                                    <select class="form-control" size="large" v-model="inputFormat">
                                        <option v-for="option in formatOptions" v-bind:value="option.key" v-bind:key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>
                        </div> -->
                    </div>
                </div>
                <div class="col-md-3">
                </div>
            </div>
    
            <div class="row">
                <div class="col-md-12">
                    <br>
                    <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                    <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                    <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="(inputStatus=='V'?'voided-':'')+currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                        <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                    </vue-json-to-csv>
                    <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="(inputStatus=='V'?'voided-':'')+currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                        <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                    </download-excel>
                </div>
            </div>
        </div>
    </a-spin>
    </template>
    
    <script>
        import HTTPRequest from '../../controllers/httpRequest.js'
        import secureStorage from '../../controllers/secureStorage';
        import reportUtils from '../../components/reportUtils'
        import moment from 'moment';
        import jsPDF from 'jspdf';
        import 'jspdf-autotable';
        import VueJsonToCsv from 'vue-json-to-csv';
    
        import {
            mapState
        } from 'vuex'
    
        export default {
            data() {
                return {
                    spinning: false,
                    inputDate: [moment().startOf('day'), moment().endOf('day')],
                    currDate: moment().format("L_LT").split(":").join(";"),
                    inputStatus: 'P',
                    statusOptions: [
                        {key: 'P', value: 'Posted'},
                        {key: 'V', value: 'Voided'}
                    ],
                    // formatOptions: [
                    //     {key: '1', value: 'Simple'},
                    //     {key: '2', value: 'Extended'}
                    // ],
                    inputFormat: 1,
                    inputSortBy: 'terminal_id',
                    sortOptions: [
                        {key: 'terminal_id', value: 'Terminal'},
                        {key: 'encoded_by', value: 'Encoder'},
                    ],

                    inputSite: [],
                    site_type: "ho",
                    showSortInfo: 'asc',

                    siteOptions: [],
                    birSalesReports: [],
                    JsonData: []
                }
            },
            mounted: async function () {
                var component_x = this;
                var userId = secureStorage.getItem("userId")
                var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
                component_x.siteOptions = sites;
                component_x.sort(component_x.siteOptions);
    
                let siteId = secureStorage.getItem("defaultSiteId")
                this.inputSite = [siteId]
    
                let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
                if(site != undefined){
                    this.site_type = site.site_type
                }

                this.inputStatus = "P"
                this.statusOptions = [{key: 'P', value: 'Posted'},{key: 'V', value: 'Voided'}]
            },
            computed: {
                ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
            },
            components:{
                VueJsonToCsv
            },
            methods: {
                moment,
                filterOption(input, option) {
                    return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                },
                sort(data){
                    data.sort(function (a, b) {
                        return a.name.localeCompare(b.name);
                    });
                },
                convertToCurrency(num){
                    return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
                },
                openNotificationWithIcon(type, msg) {
                    this.$notification[type]({
                        message: 'Export Error',
                        description: msg 
                    });
                },
                // Advanced Info
                showSortInfoDiv(){
                    this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
                },
                generateReport: async function () {
                    this.spinning= true;
                    let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                    let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'collection_journal?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&status=' + this.inputStatus, null);

                    if(this.inputDate.length == 0){
                        this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                        return
                    }
                    let reportLogo = document.getElementById('reportLogo');

                    var siteSpecific = get_request;
                    if(siteSpecific.length > 0){
                        let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                        for(var x=0; x < siteSpecific.length; x++){
                            doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                            doc.setFontSize(14);
                            doc.setFontType("bold");

                            let design_y = 20
                            
                            
                            doc.text(15,design_y,this.inputStatus == 'V' ? `Voided Collection Journal` : `Collection Journal`)
                            doc.setFontType("normal");
                            doc.setFontSize(10);

                            design_y = design_y + 5;
                            doc.text(15,design_y,"Date Range: " + this.inputDate[0].format('MMMM DD, YYYY hh:mm A')  + " to " + this.inputDate[1].format('MMMM DD, YYYY hh:mm A'))

                            if(x > 0){
                                //add new page
                                doc.addPage();
                            }

                            design_y = design_y + 10;
                            doc.text(15,design_y,"Store Name: " + siteSpecific[x].report_details[0].site_name)

                            this.birSalesReports = siteSpecific[x].report_details

                            let grouper = ''

                            let detailColStyles = {
                                0: {cellWidth: 30},
                                1: {cellWidth: 25},
                                2: {cellWidth: 25},
                                3: {cellWidth: 37},
                                4: {cellWidth: 10},
                                5: {cellWidth: 35},
                                6: {cellWidth: 20},
                                7: {cellWidth: 27},
                                8: {cellWidth: 20},
                                9: {cellWidth: 20},
                                10: {cellWidth: 30},
                                11: {cellWidth: 28},
                                12: {cellWidth: 23}
                            } 
                            
                            let header = [
                                // {content: 'Id', styles: {halign: 'center'}},
                                {content: 'Terminal', styles: {halign: 'center'}},
                                {content: 'Created Date', styles: {halign: 'center'}},
                                {content: 'Encoded By', styles: {halign: 'center'}},
                                {content: 'Collection #', styles: {halign: 'center'}},
                                {content: 'AR #', styles: {halign: 'center'}},
                                {content: 'Collection Type', styles: {halign: 'center'}},
                                {content: 'Payment Type', styles: {halign: 'center'}},
                                {content: 'Amount', styles: {halign: 'center'}},
                                {content: 'Guest Name', styles: {halign: 'center'}},
                                {content: 'Delivery #', styles: {halign: 'center'}},
                                {content: 'Receiving Store', styles: {halign: 'center'}},
                                {content: 'Event Contract #', styles: {halign: 'center'}},
                                {content: 'Scheduled Date', styles: {halign: 'center'}}
                            ]
                            // pdf
                            if(this.birSalesReports.length > 0){
                                let reportData = []
                                // let grouper = 'start'
                                
                                // let sub_amount = 0
                                let total_amount = 0
                                
                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
                                    
                                    // let grouper_name = reportLine.site_name.toUpperCase()
                                    // if (grouper == 'start' || grouper != reportLine.site_name) {
                                    //     let detail_header = [{ content: grouper_name, olSpan: 2, styles: { halign: 'left', fontStyle: 'bold' } }];
                                    //     reportData.push(Object.assign({}, detail_header))
                                    // }

                                    // grouper = reportLine.site_name

                                    //body
                                    let detail = [
                                        // {content: reportLine.id, styles: {halign: 'left'}},
                                        {content: reportLine.terminal_name, styles: {halign: 'left'}},
                                        {content: moment(reportLine.created_date).format("YYYY-MM-DD"), styles: {halign: 'center'}},
                                        {content: reportLine.encoded_by, styles: {halign: 'left'}},
                                        {content: reportLine.trans_no, styles: {halign: 'center'}},
                                        {content: reportLine.ar_no, styles: {halign: 'center'}},
                                        {content: reportLine.collection_type, styles: {halign: 'left'}},
                                        {content: reportLine.payment_type, styles: {halign: 'left'}},
                                        {content: this.convertToCurrency(Number(reportLine.amount)), styles: {halign: 'center'}},
                                        {content: reportLine.guest_name, styles: {halign: 'left'}},
                                        {content: reportLine.delivery_no || '-', styles: {halign: 'left'}},
                                        {content: reportLine.receiving_store || '-', styles: {halign: 'left'}},
                                        {content: reportLine.event_contract_no || '-', styles: {halign: 'left'}},
                                        {content: moment(reportLine.scheduled_date).format("YYYY-MM-DD"), styles: {halign: 'center'}},
                                    ]
                                    
                                    // sub_amount += Number(reportLine.amount)
                                    total_amount += Number(reportLine.amount)
                                    reportData.push(detail)
                                    
                                    let total_detail = []
                                    let site_detail = []
                                    let sub_detail = []
                                    if(i == this.birSalesReports.length-1){
                                        
                                        // sub_detail = [
                                        //     {content: `Total for: ${grouper_name}`, styles: { halign: 'left'}}, '', '',
                                        //     // {content: this.convertToCurrency(0), styles: {fontStyle: 'bold'}},
                                        //     // {content: this.convertToCurrency(sub_gross), styles: {fontStyle: 'bold'}},
                                        //     {content: this.convertToCurrency(sub_amount), styles: {fontStyle: 'bold'}}
                                        // ]
                                        // reportData.push(Object.assign({}, ["rowLine"]))
                                        // reportData.push(sub_detail)

                                        total_detail = [
                                            {content: 'Total Amount: ', styles: {fontStyle: 'bold', halign: 'left'}}, '', '', '', '', '', '',
                                            // {content: this.convertToCurrency(total_qty), styles: {fontStyle: 'bold'}},
                                            // {content: this.convertToCurrency(total_gross), styles: {fontStyle: 'bold'}},
                                            {content: this.convertToCurrency(total_amount), styles: {fontStyle: 'bold'}}
                                        ]

                                        // site_detail = [
                                        //     {content: `Site Name: ${reportLine.site_name}`, styles: {fontStyle: 'bold', halign: 'left'}}, '', '', '', ''
                                        // ]

                                        reportData.push(Object.assign({}, ["rowLine"]))
                                        reportData.push(total_detail)
                                        // reportData.push(site_detail)

                                        //create table
                                        design_y = design_y + 5
                                        doc.autoTable({
                                            startY: design_y, 
                                            head: [header],
                                            body: reportData, 
                                            theme: 'plain',
                                            tableWidth: 'wrap',
                                            headStyles: {
                                                lineWidth: 0.15
                                            },
                                            styles: {
                                                cellPadding: 1.0, fontSize: 9,
                                                halign: 'right'
                                            },
                                            columnStyles: detailColStyles,
                                            didParseCell: function(data) {
                                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                                    data.cell.styles.fillColor = [0, 0, 0]
                                                    data.cell.styles.fontSize = 1
                                                    data.cell.styles.cellPadding = 0
                                                } else if (data.row.section == 'body' && data.row.raw[6] == 'Total :'){
                                                    data.cell.styles.fontStyle = 'bold'
                                                }
                                            }
                                        });
                                    } // else {
                                        // let current_grouper = ""
                                        // let next_grouper = ""

                                        // current_grouper = reportLine.category
                                        // next_grouper = this.birSalesReports[i+1].category

                                        // if(current_grouper != next_grouper){
                                        //     sub_detail = [
                                        //         {content: `Total for: ${grouper_name}`, styles: { halign: 'left'}}, '', '',
                                        //         // {content: this.convertToCurrency(sub_qty), styles: {fontStyle: 'bold'}},
                                        //         // {content: this.convertToCurrency(sub_gross), styles: {fontStyle: 'bold'}},
                                        //         {content: this.convertToCurrency(sub_amount), styles: {fontStyle: 'bold'}}
                                        // ]
                                        // reportData.push(Object.assign({}, ["rowLine"]))
                                        // reportData.push(sub_detail)
        
                                        // total_detail = [ 
                                        //     {content: 'Grand Total: ', styles: {fontStyle: 'bold', halign: 'left'}}, '', '', 
                                        //     // {content: this.convertToCurrency(total_qty), styles: {fontStyle: 'bold'}},
                                        //     // {content: this.convertToCurrency(total_gross), styles: {fontStyle: 'bold'}},
                                        //     {content: this.convertToCurrency(total_amount), styles: {fontStyle: 'bold'}}
                                        // ]

                                        // sub_amount = 0
                                        
                                        
                                    // }
                                }
                            }
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        let pageCount = doc.internal.getNumberOfPages();
                        let footer_x = 340
                        let footer_y = 205
                        for(let i = 1; i <= pageCount; i++) { 
                            doc.setPage(i);
                            // doc.text(480,340,"Page " + doc.internal.getCurrentPageInfo().pageNumber  + " of " + pageCount, "right")
                            reportUtils.pdfTools.addFooter(doc, printed_by, this.inputStatus == 'V' ? `Voided Collection Journal` : `Collection Journal`, footer_x, footer_y, i, pageCount)
                        }
                        window.open(URL.createObjectURL(doc.output("blob")))
                    } else {
                        this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    }
                    this.spinning = false;
                },
                generateFile: async function() {
                    this.spinning= true;
                    let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                    let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                    let from_header = this.inputDate[0].format('YYYY-MM-DD');
                    let to_header= this.inputDate[1].format('YYYY-MM-DD');

                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'collection_journal?site_id=' + this.inputSite + '&date_from=' + from_date + '&date_to=' + to_date + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo + '&status=' + this.inputStatus, null);

                    if(this.inputDate.length == 0){
                        this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                        return
                    }

                    var siteSpecific = get_request;
                    if(siteSpecific.length > 0){
                        let headers = [];
                        let site_specific = [];
                        for(var x=0; x < siteSpecific.length; x++){
                            this.birSalesReports = siteSpecific[x].report_details

                            let grouper = ''

                            headers = ['Site Name', 'Terminal Name', 'Created Date','Encoded By', 'Collection #', 'AR #', 'Collection Type', 'Payment Type', 'Amount', 'Guest Name', 'Delivery Number', 'Receiving Store', 'Event Contract Number', 'Pickup/Delivery/Event Date']
                            let reportData = []
                            if(this.birSalesReports.length > 0){
                                // let grouper = 'start'
                                
                                let sub_amount = 0

                                let total_amount = 0

                                for(let i=0; i < this.birSalesReports.length; i++){
                                    let reportLine = this.birSalesReports[i]
                                    // reportData.push(Object.assign({}, [" "]))
                                    // let grouper_name = reportLine.site_name
                                    // if (grouper == 'start' || grouper != reportLine.category) {
                                    //     let detail_header = [grouper_name];
                                    //     reportData.push(Object.assign({}, detail_header))
                                    // }

                                    // grouper = reportLine.site_name

                                    //body

                                    let detail = [
                                        reportLine.site_name,
                                        reportLine.terminal_name,
                                        moment(reportLine.created_date).format("YYYY-MM-DD"),
                                        reportLine.encoded_by,
                                        reportLine.trans_no,
                                        reportLine.ar_no,
                                        reportLine.collection_type,
                                        reportLine.payment_type,
                                        this.convertToCurrency(Number(reportLine.amount)),
                                        reportLine.guest_name,
                                        reportLine.delivery_no,
                                        reportLine.receiving_store,
                                        reportLine.event_contract_no,
                                        moment(reportLine.scheduled_date).format("YYYY-MM-DD")
                                    ]
                                                            
                                    // sub_amount += Number(reportLine.amount)
                                    total_amount += Number(reportLine.amount)
                                
                                    reportData.push(detail)
                    
                                    let total_detail = []
                                    let site_detail = []
                                    let sub_detail = []
                                    if(i == this.birSalesReports.length-1){
                                        // sub_detail = [`Total for: ${grouper_name}`, '', '', 
                                        //     // this.convertToCurrency(sub_qty),
                                        //     // this.convertToCurrency(sub_gross),
                                        //     this.convertToCurrency(sub_amount)
                                        // ]
                                        // reportData.push(sub_detail)
                                        reportData.push(Object.assign({}, [" "]))
                                        total_detail = ['Total Amount: ', '', '', '', '', '', '', '',
                                            // this.convertToCurrency(total_qty),
                                            // this.convertToCurrency(total_gross),
                                            this.convertToCurrency(total_amount)
                                        ]
                                        site_detail = [
                                            `Site Name: ${reportLine.site_name} `, '', '', '', ''
                                        ]

                                        reportData.push(total_detail)
                                        reportData.push(site_detail)
                                    } // else {
                                        // let current_grouper = ""
                                        // let next_grouper = ""

                                        // current_grouper = reportLine.site_name
                                        // next_grouper = this.birSalesReports[i+1].site_name

                                        // if(current_grouper != next_grouper){
                                        //     sub_detail = [`Total for: ${grouper_name}`, '', '',  
                                        //         // this.convertToCurrency(sub_qty),
                                        //         // this.convertToCurrency(sub_gross),
                                        //         this.convertToCurrency(sub_amount)
                                        //     ]
                                        //     reportData.push(sub_detail)
                                        //     reportData.push(Object.assign({}, [" "]))

                                        //     sub_amount = 0
                                        // }   
                                    // }
                                }
                            }

                            let printed_by = secureStorage.getItem("email")
                            if(printed_by == null){
                                printed_by = ''
                            }

                            reportData.push([])
                            reportData.push([this.inputStatus == 'V' ? `Voided Collection Journal` : `Collection Journal`, "Generated By: " + printed_by,"","","","","","","","","","","","For the Period of " + from_header + " to " + to_header])
                            reportData.push([])

                            let keys = headers;
                            let values = reportData;
                            var values_length = values.length;

                            let newJsonData=[];

                            // change headers and report data as key and value object
                            for(var i=0;i < values_length; i++){
                                var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                        [val]: values[i][index]
                                    }
                                )
                                )
                            );
                            newJsonData.push(result)
                            }

                            // change undefined on arr
                            newJsonData.forEach(function(obj) {
                            for(var i in obj) {
                                if(obj[i] === undefined || obj[i] === null ) {
                                obj[i] = '';
                                }
                            }
                            });
                            site_specific.push(newJsonData)
                        }
                        this.JsonData = site_specific.flat(Infinity);
                    } else {
                        this.openNotificationWithIcon('error', 'No Data');
                    }
                    this.spinning= false;
                },
                clearJsonData(){
                  // console.log("working",this.JsonData)
                  this.JsonData = [];
                },
            },
        };
    </script>
    
    <style></style>